import cloud_platforms from '../../images/cloud_platforms.png';
import architecture from '../../videos/architecture.mp4';

export const homeObjOne = {
  id: 'on-demand',
  lightBg: false,
  lightText: true,
  topLine: 'On-demand',
  headline: 'Digital Services',
  description:
    'We provide A–Z digital solutions from ranking your webpage on Google to improving your ranking, from Instagram to TikTok social media handling, and from photography to editing your content.',
  buttonLabel: 'Home',
  imgStart: false,
  video: architecture,
  alt: 'Digital services',
  dark: true,
  primary: true,
  darkText: false,
  buttonLink: 'digital-home',
};

export const homeObjTwo = {
  id: 'platforms',
  lightBg: true,
  lightText: false,
  topLine: 'Platforms',
  headline: 'Services We Offer',
  numberedListItems: [
    'Social Media Handling',
    'Creating Virtual Tours',
    'Google SEO and Ads campaigns',
    'Influencer Collaborations & Boosting',
  ],
  buttonLabel: 'Scroll Top',
  imgStart: true,
  img: cloud_platforms,
  alt: 'Platforms',
  dark: false,
  primary: false,
  darkText: true,
  buttonLink: 'digital-home',
};
